import GetAppIcon from '@material-ui/icons/GetApp';
import { Linked } from "@type-r/models";
import { asDateTimeUTC, asTimelessDateUTC, colors, Flex, navigate } from "lqx-react";
import React from "react";
import { ImportJob } from "../api/importJob";
import { AssetTypeName, Body, Container, Footer, FooterContent, FooterLabel, FooterRow, ModifyLabel, NameBlock, NameLabel, NavigateTemplateLink, PolicyCardDate, PolicyName, Row, State, StyledIconButton } from "../components/item-card-styles";
import { DigiTooltip, downloadOriginalFile, limitText } from "../shared";
import { ImportJobActions } from "./import-job-actions";
import { ImportJobStatusType } from "./models/ImportJobStatusType";

export const ImportJobsCardRenderer = (
    $doProcessJob: Linked<{ jobId?: Number, needApproval?: boolean, actionType?: String, assetTypeId: Number }>,
    $activeCard: Linked<ImportJob>) =>
    ({ data, style, index, $ }) => {
        const importJob: ImportJob = data.items[index];
        const isActive = Boolean($activeCard.value) && importJob.jobId === $activeCard.value.jobId;

        const getAssetType = (assetId: any) => assetId ? assetId.name : 'Unknown asset type';
        const getColorBasedOnImportJobStatus = (statusName: string) => {
            if (Boolean(statusName)) {
                switch (statusName) {
                    case ImportJobStatusType.Processed:
                        return colors.blue;
                    case ImportJobStatusType.Closed:
                        return colors.lightGrey;
                    case ImportJobStatusType.ErrorProcessing:
                        return colors.red;
                }
            }
            return colors.grey;
        }

        //const openDetailsSection = (statusId: any) => statusId.name === ImportJobStatusType.Processed || statusId.name === ImportJobStatusType.ErrorProcessing;

        const isProcessing = () =>
            Boolean($doProcessJob.value.jobId) &&
            !Boolean($doProcessJob.value.needApproval) &&
            importJob.jobId == $doProcessJob.value.jobId;

        const getImportJobStatusName = () => isProcessing() ?
            ImportJobStatusType.Reprocessing : (importJob && importJob.statusId && importJob.statusId.name) ?
                importJob.statusId.name : '';

        const handleDownloadOriginalFile = (e: any, url: string, fileName: string): any => {
            e.stopPropagation();
            return downloadOriginalFile(url, fileName);
        }

        return (
            <Row style={style}>
                <Flex row grow>
                    <Container {...{ active: isActive ? 'true' : 'false' }} {...{ onClick: () => { $activeCard.set(importJob) } }}>
                        <Body {...{ active: isActive ? 'true' : 'false' }}>
                            <Flex row>
                                <Flex column grow>
                                    <NameBlock>
                                        <State style={{ color: getColorBasedOnImportJobStatus(getImportJobStatusName()) }}>{getImportJobStatusName()}</State>
                                        <AssetTypeName> {getAssetType(importJob.assetTypeId)}</AssetTypeName>
                                        {importJob.modifyExistingAssets ? <ModifyLabel> Modifies Existing</ModifyLabel> : "" }
                                        <PolicyName> {importJob.errorMsg && ` | ${importJob.errorMsg}`}</PolicyName>
                                    </NameBlock>
                                    <Flex>
                                        <PolicyCardDate>
                                            {importJob.isManual ? <NameLabel>Manual</NameLabel> : <>
                                                <NameLabel>
                                                    {importJob.originalFileName.length > 90
                                                        ? <DigiTooltip title={importJob.originalFileName}>
                                                            <span>{limitText(importJob.originalFileName, 90)}</span>
                                                        </DigiTooltip>
                                                        : importJob.originalFileName
                                                    }
                                                    <StyledIconButton aria-label="Download" size="small"
                                                        onClick={(e) => handleDownloadOriginalFile(e, `/api/v1/ingest/jobs/${importJob.documentId}/file`, importJob.originalFileName)}>
                                                        <GetAppIcon />
                                                    </StyledIconButton>
                                                </NameLabel></>}
                                        </PolicyCardDate>
                                    </Flex>
                                </Flex>
                                <Flex column>
                                    {!$activeCard.value && <ImportJobActions $doProcessJob={$doProcessJob} importJob={importJob}></ImportJobActions>}
                                </Flex>
                            </Flex>
                        </Body>
                        <Footer>
                            <Flex column>
                                <FooterRow>
                                    {/* <FooterLabel>Initiated On:</FooterLabel><FooterContent>{asDateTime(importJob.initiatedOn)}</FooterContent> */}
                                    <FooterLabel>Processed On:</FooterLabel><FooterContent>{importJob.processedOn ? asDateTimeUTC(importJob.processedOn) : asDateTimeUTC(importJob.initiatedOn)}</FooterContent>
                                    {!$activeCard.value && <>
                                        <FooterLabel>Created By:</FooterLabel><FooterContent>{importJob.createdBy}</FooterContent>
                                    </>}
                                </FooterRow>
                            </Flex>
                            {!$activeCard.value &&
                                <Flex column grow>
                                    <FooterRow style={{ marginLeft: 'auto' }}>
                                        <FooterLabel>Import Template Name:</FooterLabel>
                                        <FooterContent>
                                            {
                                                importJob.isStandard
                                                    ? importJob.displayImportTemplateName
                                                    : <NavigateTemplateLink onClick={() => navigate(`import-templates/edit/${importJob.importTemplateId}`)}>
                                                        {importJob.displayImportTemplateName}
                                                    </NavigateTemplateLink>
                                            }
                                        </FooterContent>
                                        <FooterLabel>Connection ID:</FooterLabel><FooterContent>{importJob.connectionId}</FooterContent>
                                        <FooterLabel>Job Id:</FooterLabel><FooterContent>{importJob.jobId}</FooterContent>
                                    </FooterRow>
                                </Flex>}
                        </Footer>
                    </Container>
                </Flex>
            </Row>
        )
    }
